// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"237":"1b3b2b36","401":"d1253013","751":"ef0b0256"}[chunkId] + ".chunk.css";
};